import * as React from 'react'
import { chakra } from '../../chakra'
import { AmazonLogo } from './Amazon'
import { EbayLogo } from './Ebay'
import { EtsyLogo } from './Etsy'
import { ExigoLogo } from './Exigo'
import { ShipstationLogo } from './Shipstation'
import { ShopifyLogo } from './Shopify'
import { WoocommerceLogo } from './Woocommerce'
import type { PlatformLogoProps } from './types'

export type { PlatformLogoProps } from './types'

export interface PlatformLogoWithCodeProps extends PlatformLogoProps {
  platform: string
}

// Fallback logo for unknown platforms
const UnknownLogo = React.forwardRef<SVGSVGElement, PlatformLogoProps>(
  function UnknownLogo(props, ref) {
    const { w, width, ...restProps } = props
    // Default to w="4" (16px)
    const computedWidth = w !== undefined ? w : width !== undefined ? width : '4'

    return (
      <chakra.svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        color="fg.muted"
        w={computedWidth}
        {...restProps}
        ref={ref}
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
      </chakra.svg>
    )
  },
)

const PLATFORM_MAP: Record<string, React.ComponentType<PlatformLogoProps>> = {
  AMAZON: AmazonLogo,
  AMAZON2: AmazonLogo,
  EBAY: EbayLogo,
  EBAY2: EbayLogo,
  ETSY: EtsyLogo,
  EXIGO: ExigoLogo,
  SHIPSTATION: ShipstationLogo,
  SHOPIFY: ShopifyLogo,
  WOOCOMMERCE: WoocommerceLogo,
}

export const PlatformLogo = ({ platform, ...props }: PlatformLogoWithCodeProps) => {
  const Logo = PLATFORM_MAP[platform?.toUpperCase()]

  if (Logo) {
    return <Logo {...props} />
  }

  // Fallback for unknown platforms
  return <UnknownLogo {...props} />
}
